/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { Sample } from './transport.model';

export interface CollectionBin {
  id: number;
  serialNumber: string;
  collectionBinType: CollectionBinType;
  containerTypeName: string;
  capacity: number;
  wastedCount: number;
  wastedVolume: number;
  isActive: boolean;
  percentFull: number;
  binExpiry: Date;
  binExpired: boolean;
}

export interface CollectionBox {
  containerTypeName: string;
  capacity: number;
  wastedCount: number;
  samples: Sample[];
  percentFull: number;
}

export enum CollectionBinType {
  NonHazardous,
  Hazardous,
}
